export enum DataInsightType {
  AnomalousCost = 'Anomalous Cost',
  AnomalousCostPerUnit = 'Anomalous Cost per Unit',
  AnomalousUsage = 'Anomalous Usage',
  BillGap = 'Bill Gap',
  BillOnInactiveAccount = 'Bill on Inactive Account',
  BillPeriodTooLong = 'Bill Period Too Long',
  ChargesOnlyMeterWithUsageLineItems = 'Charges Only Meter with Usage Line Items',
  DateRecency = 'Data Recency',
  DuplicateBill = 'Duplicate Bill',
  DuplicateBudgetPeriods = 'Duplicate Budget Periods',
  InvalidBillDate = 'Invalid Bill Date',
  LineItemDateOverlap = 'Line Item Date Overlap',
  LineItemGap = 'Line Item Gap',
  MeterAssignedToDefaultFacility = 'Meter Assigned to Default Facility',
  MeterNotOnBillAccount = 'Meter Not on Bill Account',
  MeterUsageIncreasingOverTime = 'Meter Usage Increasing Over Time',
  MissingBudgetPeriod = 'Missing Budget Period',
  MissingDemandLineItems = 'Missing Demand Line Items',
  NoUsageLineItem = 'No Usage Line Items',
  UsageAfterInactiveDate = 'Usage After Inactive Date',
  UsageAfterCurrentDate = 'Usage After Current Date',
  UsageUnitChanged = 'Usage Unit Changed',
  UsageWithoutCost = 'Usage Without Cost',
}
